import { type MonthlyTourReportExEntity } from '@/libs/api'

/**
 * 月次支払レポートステータス
 *
 * 画面に出す名前は見る立場で変わるため、features/approval-workflow/models の
 * getMonthlyTourReportStatusLabel で引く
 * */
export type MonthlyTourReportStatus = MonthlyTourReportExEntity['status']

export const MONTHLY_TOUR_REPORT_STATUS = {
  /** パートナー作成中 */
  PARTNER_CONFIRM_PENDING: 'PARTNER_CONFIRM_PENDING',
  /** パートナー再確認 */
  PARTNER_RECONFIRM_PENDING: 'PARTNER_RECONFIRM_PENDING',
  /** 確認待ち */
  DC_CONFIRM_PENDING: 'DC_CONFIRM_PENDING',
  /** センター再確認 */
  DC_RECONFIRM_PENDING: 'DC_RECONFIRM_PENDING',
  /** センター最終確認待ち */
  DC_FINAL_CONFIRM_PENDING: 'DC_FINAL_CONFIRM_PENDING',
  /** 確認済 */
  CONFIRMED: 'CONFIRMED'
} as const satisfies Record<MonthlyTourReportStatus, MonthlyTourReportStatus>
